(() => {
  'use strict';
  const language = (document.documentElement.lang || 'en').toLowerCase();
  const country = document.documentElement.dataset.jfCountry || 'US';
  const bodyLabels = {en:'Body measurements',nl:'Lichaamsmaten',pl:'Wymiary ciała',pt:'Medidas do corpo',sv:'Kroppsmått'};
  const lang = language.startsWith('sv')?'sv':language.startsWith('nl')?'nl':language.startsWith('pl')?'pl':language.startsWith('pt')?'pt':'en';
  function init(root) {
    if (lang === 'sv') {
      const labels = {'Size Chart':'Storlekstabell','Size chart':'Storlekstabell','Size':'Storlek','Label':'Storlek','EU reference':'EU-storlek','Bust':'Byst','Chest':'Bröst','Waist':'Midja','Hip':'Höft','Hips':'Höft','Shoulder':'Axelbredd','Shoulders':'Axelbredd','Sleeve':'Ärmlängd','Sleeve Length':'Ärmlängd','Length':'Längd','Body measurements':'Kroppsmått','Centimeters':'Centimeter','Inches':'Tum'};
      root.querySelectorAll('[data-jf-size-chart] h2, [data-jf-size-chart] h3, [data-jf-size-chart] th, [data-jf-size-chart] summary').forEach(el => {
        const text = el.textContent.trim();
        const match = text.match(/^(.*?)(\s*\((?:cm|in)\))?$/);
        if (match && labels[match[1]]) el.textContent = labels[match[1]] + (match[2] || '');
      });
    }
    root.querySelectorAll('[data-jf-size-chart]').forEach(chart => {
      if (chart.dataset.ready) return;
      const panels = [...chart.querySelectorAll('[data-jf-unit]')];
      if (panels.length < 2) return;
      const controls = document.createElement('div'); controls.className = 'jf-size-chart__controls'; controls.setAttribute('role','group'); controls.setAttribute('aria-label', {en:'Measurement units',nl:'Maateenheid',pl:'Jednostka miary',pt:'Unidade de medida',sv:'Måttenheter'}[lang]);
      const buttons = panels.map(panel => {
        const button=document.createElement('button');button.type='button';button.textContent=panel.dataset.jfUnit==='in'?'IN':'CM';button.dataset.unit=panel.dataset.jfUnit;
        button.addEventListener('click',()=>select(panel.dataset.jfUnit));controls.appendChild(button);return button;
      });
      function select(unit) {panels.forEach(p=>{p.open=true;p.hidden=p.dataset.jfUnit!==unit;});buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.unit===unit)));}
      chart.insertBefore(controls,panels[0]);chart.dataset.ready='true';chart.classList.add('jf-size-chart--ready');
      const note=chart.querySelector('[data-jf-chart-note="body"]');if(note)note.textContent=bodyLabels[lang];
      select(country==='US'?'in':'cm');
    });
    root.querySelectorAll('.sm-description table').forEach(table=>{
      if(table.closest('.jf-size-chart, .jf-legacy-table-scroll'))return;
      const wrap=document.createElement('div');wrap.className='jf-legacy-table-scroll';wrap.tabIndex=0;table.before(wrap);wrap.appendChild(table);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
